import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@components/Button/Button'
import Footer from '@components/Footer'
import Header from '@components/Header'
import Page from '@components/Page'
import { SelectableTile } from '@components/SelectableTile/SelectableTile'
import useStyles from './styles'
import { useIsPhoneOnly } from 'src/config/mediaQueries'
import { selectPatient, useVerifyPhoneContext, useVerifyPhoneDispatch } from '@context/VerifyPhoneContext'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { ReturningPatient } from 'src/services/api/verifyPhone'
import { useSelectPreferredPractitioner } from '@hooks/useSelectPreferredPractitioner'
import { TEST_IDS } from 'src/constants/testIds'
import { useChoiceDispatch, setPatientReferenceIdAndPreferredPractitionerId } from '@context/ChoiceContext'

export const SelectPatientAccountScreen = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const isPhone = useIsPhoneOnly()
  const { linkedPatients, selectedPatient } = useVerifyPhoneContext()
  const verifyPhoneDispatch = useVerifyPhoneDispatch()
  const choiceDispatch = useChoiceDispatch()
  const history = useHistory()
  const selectPreferredPractitioners = useSelectPreferredPractitioner({
    clearSelectedSlot: true,
    possibleToSetAll: false,
  })

  const onBackClicked = () => history.push(routes.patient)

  const goNext = (patient?: ReturningPatient) => {
    if (patient && patient.patientReferenceId !== selectedPatient?.patientReferenceId) {
      verifyPhoneDispatch(selectPatient(patient))
      choiceDispatch(
        setPatientReferenceIdAndPreferredPractitionerId({
          patientReferenceId: patient.patientReferenceId,
          preferredPractitionerReferenceId: patient.practitionerReferenceId,
        })
      )
      const preferredPractitionerId = patient.practitionerReferenceId
      selectPreferredPractitioners([preferredPractitionerId], patient?.patientReferenceId)
    }
    history.push(routes.appointment)
  }

  return (
    <Page
      header={
        <Header
          onBackClick={onBackClicked}
          desktopHeadingText={t('old_patient_verification_select_patient_page_desktop_headline')}
        />
      }
      body={
        <div className={classes.root} data-test={TEST_IDS.selectPatientContainer}>
          <div className={classes.text}>
            {t('old_patient_verification_select_patient_page_text_1')}
            {isPhone ? ' ' : <br />}
            {t('old_patient_verification_select_patient_page_text_2')}
          </div>
          <div className={classes.patientsContainer}>
            {linkedPatients.map((patient, index) => (
              <SelectableTile
                content={patient.fullName}
                isSelected={selectedPatient?.fullName === patient.fullName}
                key={patient.fullName}
                onClick={() => goNext(patient)}
                data-test={`${TEST_IDS.selectPatientAccount}-${index}`}
              />
            ))}
          </div>
        </div>
      }
      footer={
        <Footer
          button={
            selectedPatient ? (
              <Button
                fullSize
                type="button"
                onClick={() => goNext()}
                data-test={TEST_IDS.nextButton}
                text={t('cta_button_continue')}
              />
            ) : null
          }
        />
      }
    />
  )
}
